import { ApiError, apiFetch, apiFetchBlob } from '@/lib/api-client'

const BASE = '/feedback'

export type FeedbackChatAttachment = { id: string; contentType: string }

export type FeedbackChatMessage = {
  id: string
  from: 'user' | 'team'
  /** Ekip mesajında yazanın adı; yoksa null. */
  author?: string | null
  body: string
  createdAt: string
  attachment: FeedbackChatAttachment | null
}

export type SendFeedbackChatInput = { body: string; screenshot?: string | null }

function chatPath(trackingId: string, suffix = ''): string {
  return `${BASE}/reports/${encodeURIComponent(trackingId)}/chat${suffix}`
}

export async function getFeedbackChat(trackingId: string): Promise<FeedbackChatMessage[]> {
  const response = await apiFetch<{
    success: boolean
    data: { messages?: FeedbackChatMessage[] }
  }>(chatPath(trackingId))
  return Array.isArray(response.data?.messages) ? response.data.messages : []
}

export async function markFeedbackChatRead(trackingId: string): Promise<void> {
  await apiFetch(chatPath(trackingId, '/read'), { method: 'POST', body: JSON.stringify({}) })
}

export async function sendFeedbackChatMessage(
  trackingId: string,
  input: SendFeedbackChatInput,
): Promise<void> {
  const body: { body: string; screenshot?: string } = { body: input.body }
  if (input.screenshot) body.screenshot = input.screenshot
  await apiFetch(chatPath(trackingId, '/messages'), {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

/** Ek görseli kimlik başlığıyla çeker (`<img src>` başlık taşıyamaz); çağıran blob URL üretir. */
export function fetchFeedbackChatAttachment(
  attachmentId: string,
  signal?: AbortSignal,
): Promise<Blob> {
  return apiFetchBlob(`${BASE}/chat/attachments/${encodeURIComponent(attachmentId)}`, { signal })
}

/** Gönderim hatasını kullanıcıya düz Türkçe açıklar (sağlayıcı/teknik ayrıntı yok). */
export function chatSendErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return 'Çok hızlı mesaj gönderdin. Biraz bekleyip yeniden dene.'
    if (error.status === 502 || error.status === 503 || error.status === 504) {
      return 'Mesajın şu an iletilemedi. Yazdıkların korunuyor; biraz sonra yeniden dene.'
    }
    if (error.status === 400 || error.status === 413) {
      return 'Mesaj ya da ekran görüntüsü kabul edilmedi. Metni kısaltıp ya da görüntüyü çıkarıp yeniden dene.'
    }
    if (error.status === 401 || error.status === 403) {
      return 'Sohbet şu an kullanılamıyor. Sayfayı yenileyip yeniden dene.'
    }
  }
  return 'Mesajın gönderilemedi. Yazdıkların korunuyor; bağlantını kontrol edip yeniden dene.'
}
